export enum AuthHighlightsAudience {
  Shipper = 'Shipper',
  Fleet = 'Fleet',
}
